import PropTypes from 'prop-types';
import React from 'react';
import PreviewVideo from '../components/PreviewVideo';

const ComposablePreviewVideo = ({ articleImage, previewVideo }) => {
  return (
    <PreviewVideo articleImage={articleImage} previewVideo={previewVideo} />
  );
};

ComposablePreviewVideo.propTypes = {
  previewVideo: PropTypes.string.isRequired,
  articleImage: PropTypes.string.isRequired,
};

export default ComposablePreviewVideo;
